import React, { useState, useRef, useEffect } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "../../axiosInstance";
import { useFormik } from "formik";
import { object, string, number } from "yup";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";

// Load Google Maps
const loadGoogleMapsScript = (apiKey, callback) => {
  if (window.google && window.google.maps) {
    callback();
    return;
  }

  const script = document.createElement("script");
  script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places,geometry`;
  script.async = true;
  script.onload = callback;
  document.body.appendChild(script);
};

const validationSchema = object().shape({
  vehicle_type: string().trim().required("vehicle type is required"),
  city: string().trim().required("City is required"),
  radius_from_retailer: number()
    .typeError("Radius must be a number")
    .min(0, "Radius cannot be negative")
    .required("Radius from retailer is required"),
  charge_per_km: number()
    .typeError("Charge must be a number")
    .min(0, "Charge per km cannot be negative")
    .required("Charger per km is required"),
  gomak_commision: number()
    .typeError("Charge must be a number")
    .min(0, "Charge per km cannot be negative")
    .required("Charger per km is required"),
  ryder_gst: number()
    .typeError("Charge must be a number")
    .min(0, "Charge per km cannot be negative")
    .required("Charger per km is required"),
  gomak_gst: number()
    .typeError("Charge must be a number")
    .min(0, "Charge per km cannot be negative")
    .required("Charger per km is required"),
  minimum_charge: number()
    .typeError("Charge must be a number")
    .min(0, "Charge per km cannot be negative")
    .required("Charger per km is required"),
  // gomakcash_amount: number()
  //   .typeError("Gomak cash amount must be a number")
  //   .min(0, "Gomak cash amount cannot be negative")
  //   .when("gomakcash_active", {
  //     is: true,
  //     then: (schema) => schema.required("Gomak cash amount is required"),
  //     otherwise: (schema) => schema.notRequired(),
  //   }),
});

export const AddRyderZone = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [mapModalOpen, setMapModalOpen] = useState(false);
  const [selectedCityLatLng, setSelectedCityLatLng] = useState(null);

  const mainMapRef = useRef(null);
  const modalMapRef = useRef(null);

  const mapInstance = useRef(null);
  const markerRef = useRef(null);
  const polygonRef = useRef(null);
  const autocompleteRef = useRef(null);

  const DEFAULT_CENTER = { lat: 20.5937, lng: 78.9629 };
  const API_KEY = "AIzaSyBNZ6QvXiknFj5OmY4hnUxPoWDnmtQiLko";

  // ⭐ ADDED: Find city center from city name using Google Places API
  const getCityCenterFromPlaceName = async (placeName) => {
    return new Promise((resolve) => {
      const service = new window.google.maps.places.PlacesService(
        document.createElement("div"),
      );

      service.findPlaceFromQuery(
        {
          query: placeName,
          fields: ["name", "geometry"],
        },
        (results) => {
          if (results && results.length && results[0].geometry) {
            resolve(results[0].geometry.location);
          } else {
            resolve(null);
          }
        },
      );
    });
  };

  // ⭐ ADDED: Calculate distance (in KM)
  const calculateDistanceBetweenPoints = (lat1, lng1, lat2, lng2) => {
    const p1 = new window.google.maps.LatLng(lat1, lng1);
    const p2 = new window.google.maps.LatLng(lat2, lng2);
    const distanceMeters =
      window.google.maps.geometry.spherical.computeDistanceBetween(p1, p2);

    return distanceMeters / 1000; // KM
  };

  const formik = useFormik({
    initialValues: {
      vehicle_type: "",
      city: "",
      latitude: "",
      longitude: "",
      radius_from_retailer: 5,
      charge_per_km: "",
      gomak_commision: "",
      ryder_gst: "",
      gomak_gst: "",
      minimum_charge: "",
      snap_order_commision: "",
      adhoc_order_commision: "",
      // is_active: true,
      is_active:false,
      status: true,
      is_enabled: true,
      // gomakcash_amount: "",
      // gomakcash_active: false,
      // gomakcash_start_date: null,
      // gomakcash_end_date: null,
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const radius = parseFloat(values.radius_from_retailer);
        const charge = parseFloat(values.charge_per_km);

        if (radius < 0 || charge < 0) {
          toast.error("Distance and charge must be non-negative.");
          setLoading(false);
          return;
        }
        const payload = {
          city: values.city.trim(),
          latitude: parseFloat(values.latitude),
          longitude: parseFloat(values.longitude),
          vehicle_type: values.vehicle_type,
          radius_from_retailer: radius,
          charge_per_km: charge,
          gomak_commision: values.gomak_commision,
          ryder_gst: values.ryder_gst,
          gomak_gst: values.gomak_gst,
          minimum_charge: values.minimum_charge,
          snap_order_commision: values.snap_order_commision
            ? values.snap_order_commision
            : 0,
          adhoc_order_commision: values.adhoc_order_commision
            ? values.adhoc_order_commision
            : 0,
          // is_active: true,
          is_active:false,
          status: true,
          is_enabled: true,
          // is_enabled: values.is_enabled,
          // gomakcash_amount: values.gomakcash_active
          //   ? values.gomakcash_amount
          //   : 0,

          // gomakcash_active: values.gomakcash_active,
          // gomakcash_start_date: values.gomakcash_start_date,
          // gomakcash_end_date: values.gomakcash_end_date,
        };

        const response = await axiosInstance.post(
          "/admin/ryder-zones/",
          payload,
        );

        if (response.data.status === "success") {
          toast.success(response.data.message || "RyderZone added successfully!");
          setTimeout(() => navigate("/ryder-zone"), 1500);
        } else {
          // alert(response.data.message || "Failed to add RyderZone.");
          toast.error(response.data.message || "Something went wrong. Please try again.");
        }
      } catch (err) {
        console.error("❌ Error posting RyderZone:", err);
        // alert("Something went wrong. Please try again.");
        toast.error(err.response.data.message || "Something went wrong. Please try again.");
      } finally {
        setLoading(false);
      }
    },
  });

  const handleCancel = () => {
    formik.resetForm();
    navigate("/ryder-zone");
  };

  const VEHICLE_CHOICES = [
    { value: "2_wheeler", label: "2 Wheeler" },
    { value: "3_wheeler", label: "3 Wheeler" },
  ];

  // --------------------------
  // INIT MAIN MAP
  // --------------------------
  const initMap = (center = DEFAULT_CENTER, placeSelected = false) => {
    if (!mainMapRef.current) return;

    mapInstance.current = new window.google.maps.Map(mainMapRef.current, {
      center,
      zoom: placeSelected ? 12 : 5,
    });

    if (!placeSelected) return;

    markerRef.current = new window.google.maps.Marker({
      position: center,
      map: mapInstance.current,
      draggable: true,
    });

    drawPolygon(center, formik.values.radius_from_retailer * 1000);

    markerRef.current.addListener("dragend", async () => {
      const pos = markerRef.current.getPosition();
      updateLatLng(pos.lat(), pos.lng());
      await reverseGeocode(pos); // ⭐ Updated
      drawPolygon(pos, formik.values.radius_from_retailer * 1000);
    });
  };

  const initAutocomplete = () => {
    const ac = new window.google.maps.places.Autocomplete(
      autocompleteRef.current,
      { types: ["(cities)"] },
    );

    ac.addListener("place_changed", () => {
      const place = ac.getPlace();
      if (!place.geometry) return;

      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();

      formik.setFieldValue("city", place.name);
      updateLatLng(lat, lng);

      initMap({ lat, lng }, true);
    });
  };

  const drawPolygon = (center, radius) => {
    if (polygonRef.current) polygonRef.current.setMap(null);

    const points = [];
    for (let i = 0; i < 36; i++) {
      const angle = (360 / 36) * i;
      const p = window.google.maps.geometry.spherical.computeOffset(
        center,
        radius,
        angle,
      );
      points.push(p);
    }

    polygonRef.current = new window.google.maps.Polygon({
      paths: points,
      map: mapInstance.current,
      fillColor: "#00AAFF",
      fillOpacity: 0.3,
      strokeColor: "#1976D2",
      strokeWeight: 2,
    });
  };

  const updateLatLng = (lat, lng) => {
    formik.setFieldValue("latitude", lat);
    formik.setFieldValue("longitude", lng);
  };

  // ⭐ UPDATED — detect city → get center → calculate distance → update radius
  const reverseGeocode = async (latLng) => {
    const geocoder = new window.google.maps.Geocoder();

    geocoder.geocode({ location: latLng }, async (results) => {
      if (!results || !results.length) return;

      let cityComponent = results[0].address_components.find((c) =>
        c.types.includes("locality"),
      );

      const newCityName =
        cityComponent?.long_name || results[0].formatted_address;

      formik.setFieldValue("city", newCityName);

      // ⭐ Fetch official city center
      const cityCenter = await getCityCenterFromPlaceName(newCityName);

      if (cityCenter) {
        const radiusKM = calculateDistanceBetweenPoints(
          latLng.lat(),
          latLng.lng(),
          cityCenter.lat(),
          cityCenter.lng(),
        );

        formik.setFieldValue("radius_from_retailer", radiusKM.toFixed(2));
      }
    });
  };

  useEffect(() => {
    loadGoogleMapsScript(API_KEY, () => {
      initMap(DEFAULT_CENTER, false);
      initAutocomplete();
    });
  }, []);

  useEffect(() => {
    if (!markerRef.current) return;
    drawPolygon(
      markerRef.current.getPosition(),
      formik.values.radius_from_retailer * 1000,
    );
  }, [formik.values.radius_from_retailer]);

  useEffect(() => {
    if (mapModalOpen) {
      setTimeout(() => {
        new window.google.maps.Map(modalMapRef.current, {
          center: {
            lat: formik.values.latitude || 20.59,
            lng: formik.values.longitude || 78.96,
          },
          zoom: 12,
        });
      }, 300);
    }
  }, [mapModalOpen]);

  return (
    <>
      <div className="addAdmin-container">
        <div className="addAdmin-subcontainer d-flex justify-content-between">
          <div className="d-flex align-items-center gap-2">
            <FaArrowLeftLong
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/ryder-zone")}
            />
            <div className="add-title">Add Ryder Zone</div>
          </div>
          {/* <div className="d-flex">
            <span
              style={{
                color: "#4A5565",
                fontSize: "14px",
                paddingRight: "10px",
              }}
            >
              Enable / Disable
            </span>
            <div className="form-check form-switch">
              <input
                type="checkbox"
                className="form-check-input"
                id="toggleSwitch"
                name="is_enabled"
                checked={formik.values.is_enabled === true}
                onChange={formik.handleChange}
              />

              <label className="form-check-label" htmlFor="toggleSwitch" />
            </div>
          </div> */}
        </div>
        <form onSubmit={formik.handleSubmit}>
          <div className="ryderzone-map-container">
            <div
              ref={mainMapRef}
              style={{
                width: "100%",
                height: "400px",
                border: "1px solid #ccc",
                borderRadius: 8,
              }}
            />
          </div>
          <div className="addAdmin-content">
            <div className="addAdmin-contentLeft">
              <div className="addAdmin-field">
                <label>
                  <span className="text-danger">*</span> Vehicle Type
                </label>
                <div>
                  <select
                    name="vehicle_type"
                    value={formik.values.vehicle_type}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    <option value="">Select Vehicle Type</option>
                    {VEHICLE_CHOICES.map((vehicle) => (
                      <option key={vehicle.value} value={vehicle.value}>
                        {vehicle.label}
                      </option>
                    ))}
                  </select>

                  {formik.touched.vehicle_type &&
                    formik.errors.vehicle_type && (
                      <div className="text-danger">
                        {formik.errors.vehicle_type}
                      </div>
                    )}
                </div>
              </div>
              <div className="addAdmin-field">
                <label>
                  <span className="text-danger">*</span> Radius From Retailer
                </label>
                <div>
                  <input
                    type="number"
                    name="radius_from_retailer"
                    min="0"
                    step="0.01" // allows decimal values like 29.38
                    placeholder="Enter Your radius from retailer"
                    value={formik.values.radius_from_retailer}
                    onChange={(e) => {
                      // Ensure numeric value is stored
                      formik.setFieldValue(
                        "radius_from_retailer",
                        e.target.value === "" ? "" : parseFloat(e.target.value),
                      );
                    }}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.radius_from_retailer &&
                    formik.errors.radius_from_retailer && (
                      <div className="text-danger">
                        {formik.errors.radius_from_retailer}
                      </div>
                    )}
                </div>
              </div>
            </div>
            <div className="addAdmin-contentRight">
              <div className="addAdmin-field">
                <label>
                  <span className="text-danger">*</span> City
                </label>
                <div>
                  <input
                    type="text"
                    name="city"
                    placeholder="Enter Your city"
                    ref={autocompleteRef}
                    value={formik.values.city}
                    onChange={formik.handleChange("city")}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.city && formik.errors.city && (
                    <div className="text-danger">{formik.errors.city}</div>
                  )}
                </div>
              </div>
              <div className="addAdmin-field">
                <label>
                  <span className="text-danger">*</span> Charge Per KM
                </label>
                <div>
                  <input
                    type="number"
                    name="charge_per_km"
                    min="0"
                    step="0.01"
                    placeholder="Enter Your charge per km"
                    value={formik.values.charge_per_km}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.charge_per_km &&
                    formik.errors.charge_per_km && (
                      <div className="text-danger">
                        {formik.errors.charge_per_km}
                      </div>
                    )}
                </div>
              </div>
            </div>
            <div className="addAdmin-contentLeft">
              <div className="addAdmin-field">
                <label>
                  <span className="text-danger">*</span> Gomak Commision %
                </label>
                <div>
                  <input
                    type="number"
                    name="gomak_commision"
                    min="0"
                    placeholder="Enter Your gomak commision"
                    value={formik.values.gomak_commision}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.gomak_commision &&
                    formik.errors.gomak_commision && (
                      <div className="text-danger">
                        {formik.errors.gomak_commision}
                      </div>
                    )}
                </div>
              </div>
              <div className="addAdmin-field">
                <label>
                  <span className="text-danger">*</span> Ryder GST %
                </label>
                <div>
                  <input
                    type="number"
                    name="ryder_gst"
                    min="0"
                    placeholder="Enter Your ryder gst"
                    value={formik.values.ryder_gst}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.ryder_gst && formik.errors.ryder_gst && (
                    <div className="text-danger">{formik.errors.ryder_gst}</div>
                  )}
                </div>
              </div>

              <div className="addAdmin-field">
                <label>
                  <span className="text-danger">*</span> Minimum Charge
                </label>
                <div>
                  <input
                    type="number"
                    name="minimum_charge"
                    min="0"
                    placeholder="Enter Your minimum charge"
                    value={formik.values.minimum_charge}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.minimum_charge &&
                    formik.errors.minimum_charge && (
                      <div className="text-danger">
                        {formik.errors.minimum_charge}
                      </div>
                    )}
                </div>
              </div>
            </div>
            <div className="addAdmin-contentRight">
              <div className="addAdmin-field">
                <label>
                  <span className="text-danger">*</span> Gomak GST %
                </label>
                <div>
                  <input
                    type="text"
                    name="gomak_gst"
                    placeholder="Enter gomak gst"
                    value={formik.values.gomak_gst}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.gomak_gst && formik.errors.gomak_gst && (
                    <div className="text-danger">{formik.errors.gomak_gst}</div>
                  )}
                </div>
              </div>

              <div className="addAdmin-field">
                <label>Snap Order Commision</label>
                <div>
                  <input
                    type="number"
                    name="snap_order_commision"
                    min="0"
                    placeholder="Enter Your snap order commision"
                    value={formik.values.snap_order_commision}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>
              <div className="addAdmin-field">
                <label>Adhoc Order Commision</label>
                <div>
                  <input
                    type="number"
                    name="adhoc_order_commision"
                    min="0"
                    placeholder="Enter Your adhoc order commision"
                    value={formik.values.adhoc_order_commision}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>
            </div>
            <div className="addAdmin-contentLeft">
              {/* <div className="addAdmin-field">
                <label>
                  {formik.values.gomakcash_active === true ? (
                    <span className="text-danger">*</span>
                  ) : (
                    ""
                  )}{" "}
                  Gomak Cash Amount
                </label>
                <div>
                  <input
                    type="number"
                    name="gomakcash_amount"
                    min="0"
                    placeholder="Enter Your gomak cash amount"
                    value={formik.values.gomakcash_amount}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.gomakcash_amount &&
                    formik.errors.gomakcash_amount && (
                      <div className="text-danger">
                        {formik.errors.gomakcash_amount}
                      </div>
                    )}
                </div>
              </div> */}
            </div>
          </div>

          {/* gomak cash toggler  */}
          {/* <div className="ryderZone-Gomak-box">
            <div className="d-block">
              <h5>Gomak Cash</h5>
              <p>
                Show or hide the Cash Deposit offer for wholesalers and
                retailers in this zone
              </p>
            </div>
            <div className="form-check form-switch">
              <input
                type="checkbox"
                className="form-check-input"
                id="toggleSwitch"
                name="gomakcash_active"
                checked={formik.values.gomakcash_active === true}
                onChange={formik.handleChange}
              />

              <label className="form-check-label" htmlFor="toggleSwitch" />
            </div>
          </div> */}

          <div className="addbtnContainer">
            <div>
              <button
                type="button"
                className="admin-btnCancel"
                onClick={handleCancel}
                disabled={loading}
              >
                Cancel
              </button>
            </div>
            <div>
              <button type="submit" className="add-btnSave" disabled={loading}>
                {loading ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </form>
      </div>

      {/* Map Modal */}
      {/* <Modal
        show={mapModalOpen}
        onHide={() => setMapModalOpen(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Select City Radius</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div ref={mapRef} style={{ width: "100%", height: "400px" }}></div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-primary"
            onClick={() => setMapModalOpen(false)}
          >
            OK
          </button>
        </Modal.Footer>
      </Modal> */}
    </>
  );
};
